// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"0da25cd0","247":"854198ed","706":"82022ccb"}[chunkId] + ".chunk.css";
};